import { NAV_HREFS, NAV_LINK_KEYS, SITE_LINKS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Button } from "../ui/Button";
import { LanguageSwitcher } from "./LanguageSwitcher";

import styles from "./Header.module.css";

export function Header() {
  const { copy } = useLocale();

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a className={styles.brand} href="#top">
          <img
            className={styles.logo}
            src="/favicon.svg"
            alt=""
            width={32}
            height={32}
          />
          <span>{copy.brand}</span>
        </a>

        <nav className={styles.nav} aria-label={copy.navAria}>
          {NAV_LINK_KEYS.map((key) => (
            <a key={key} className={styles.navLink} href={NAV_HREFS[key]}>
              {copy.nav[key]}
            </a>
          ))}
        </nav>

        <div className={styles.actions}>
          <LanguageSwitcher />
          <Button
            href={SITE_LINKS.download}
            variant="ghost"
            className={styles.actionBtn}
          >
            {copy.cta.download}
          </Button>
          <Button
            href={SITE_LINKS.pricing}
            variant="secondary"
            className={styles.actionBtn}
          >
            {copy.cta.buy}
          </Button>
        </div>
      </div>
    </header>
  );
}
